module.exports = __webpack_public_path__ + "img/program-poster.159b7b30.jpg";